import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: 16,
    paddingTop: 8,
    paddingBottom: 24,
  },
  iconWrapper: {
    marginBottom: 16,
  },
  icon: {
    width: 88,
    height: 88,
  },
  title: {
    textAlign: 'center',
    marginBottom: 8,
    //color: themes.light.text[1],
  },
  description: {
    textAlign: 'center',
    color: themes.light.gray_blue[2],
    marginBottom: 24,
  },
  button: {
    width: '100%',
  },
});
